export default __webpack_public_path__ + "static/media/djinn.95d5f60c.svg";